var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 452.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd205;}.cls-2{fill:#005ead;}.cls-3{fill:#808183;}.cls-4{fill:#7eb4de;}.cls-5{fill:#04a74b;}.cls-6{fill:#a5439a;}.cls-10,.cls-12,.cls-7,.cls-8,.cls-9{fill:#fff;}.cls-8{font-size:132.06px;}.cls-10,.cls-11,.cls-12,.cls-8,.cls-9{font-family:Helvetica-Bold, Helvetica;font-weight:700;}.cls-9{font-size:106.25px;}.cls-10{font-size:105.51px;}.cls-11{font-size:100.44px;}.cls-12{font-size:105.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 400.65,
    cy: 362.08,
    rx: 67.35,
    ry: 67.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 553.12,
    cy: 362.08,
    rx: 67.35,
    ry: 67.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 705.23,
    cy: 362.08,
    rx: 67.35,
    ry: 67.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 857.89,
    cy: 362.08,
    rx: 67.35,
    ry: 67.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 96.09,
    cy: 362.08,
    rx: 67.35,
    ry: 67.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 248.17,
    cy: 362.08,
    rx: 67.35,
    ry: 67.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 98.71,
    width: 1000,
    height: 15.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 1000,
    height: 59.09
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(20.98 250)"
  }, "Dermatology"), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(66.95 401.86) scale(0.99 1)"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(221.15 401.35)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(353.48 401.11) scale(1.01 1)"
  }, "W"), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(514.84 401.47) scale(0.99 1)"
  }, "E"), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(668.87 401.35)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(826.65 401.35)"
  }, "T"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.35f5292214cc5cb189aaffc3bc8d91de.svg";
export { ForwardRef as ReactComponent };